import React, { Fragment } from 'react';

import UniversalInput from '@lib/wrappers/UniversalInput';

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { VALIDATION_ERROR_MESSAGES } from '@constants/inputs/validationErrorMessages';
import { omit } from '@utils/miscellaneous/objectHelpers';


const NamesOnSsnCardInputs = props => {

    const {
        firstNameOnSSNCard,
        middleNameOnSSNCard,
        lastNameOnSSNCard,
        suffixOnSSNCard,
        currentData,
        isInputStandalone,
        stateCode,
        ...restProps
    } = props;

    const cleanedRestProps = omit(restProps, 'children');

    return (
        <Fragment>
            <UniversalInput
                label = { {
                    text: 'ssap.input.label.first_name',
                    isLabelRequired: true
                } }
                inputData = { {
                    inputClasses: [],
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'firstNameOnSSNCard',
                    helperClasses: [],
                    value: firstNameOnSSNCard,
                    placeholder: 'ssap.input.placeholder.first_name',
                    validationType: VALIDATION_TYPES.NAME,
                    validationErrorMessage: VALIDATION_ERROR_MESSAGES.FIRST_NAME,
                    currentData: currentData,
                    fields: [ 'socialSecurityCard' ],
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
            <UniversalInput
                label = { {
                    text: 'ssap.input.label.middle_name',
                    isLabelRequired: false
                } }
                inputData = { {
                    isInputRequired: false,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'middleNameOnSSNCard',
                    helperClasses: [],
                    value: middleNameOnSSNCard,
                    placeholder: 'ssap.input.placeholder.middle_name',
                    validationType: VALIDATION_TYPES.MIDDLE_NAME,
                    validationErrorMessage: VALIDATION_ERROR_MESSAGES.MIDDLE_NAME,
                    currentData: currentData,
                    fields: [ 'socialSecurityCard' ],
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
            <UniversalInput
                label = { {
                    text: 'ssap.input.label.last_name',
                    isLabelRequired: true
                } }
                inputData = { {
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'lastNameOnSSNCard',
                    helperClasses: [],
                    value: lastNameOnSSNCard,
                    placeholder: 'ssap.input.placeholder.last_name',
                    validationType: VALIDATION_TYPES.NAME,
                    validationErrorMessage: VALIDATION_ERROR_MESSAGES.LAST_NAME,
                    currentData: currentData,
                    fields: [ 'socialSecurityCard' ],
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
            <UniversalInput
                label = { {
                    text: 'ssap.input.label.suffix',
                    isLabelRequired: false
                } }
                inputData = { {
                    isInputRequired: false,
                    type: INPUT_TYPES.DROPDOWN,
                    name: 'suffixOnSSNCard',
                    value: suffixOnSSNCard,
                    options: DROPDOWN_OPTIONS.SUFFIX(stateCode),
                    currentData: currentData,
                    fields: [ 'socialSecurityCard' ],
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
        </Fragment>
    );
};

export default NamesOnSsnCardInputs;
